var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import snakecaseKeys from "snakecase-keys";
import { __, getConfig } from "@jti/fe-common";
import { Rest } from "../../Rest";
export class PgsApiLegacy extends Rest {
    constructor(baseUrl, tenantToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.name = "PgsApi";
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    }
    placeOrder(order) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payment_token } = yield this.request("/order", {
                body: JSON.stringify(snakecaseKeys(order)),
                method: "PUT",
            });
            return payment_token;
        });
    }
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: paymentMethods } = yield this.request("/payment-methods", {
                method: "GET",
            });
            const translatedPaymentMethods = paymentMethods.map((_a) => {
                var { code, title } = _a, paymentMethod = __rest(_a, ["code", "title"]);
                // if the translation is provided, take it from the dictionary,
                // otherwise fall back to the value from PGS
                const text = __(`cart.order.payment_method.${code}`, undefined, title) || title;
                return Object.assign(Object.assign({}, paymentMethod), { code, title: text });
            });
            return { data: translatedPaymentMethods };
        });
    }
    getClient(code_1) {
        return __awaiter(this, arguments, void 0, function* (code, locale = getConfig().ISO_COUNTRY_CODE) {
            const { client } = yield this.request(`/client?payment_method_code=${code}&locale=${locale}`, {
                method: "GET",
            });
            return client;
        });
    }
    getOrderPaymentMethod(paymentToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request(`/payment/${paymentToken}`, {
                method: "GET",
            });
            const { payment_method, title, method, icon } = response, paymentMethod = __rest(response, ["payment_method", "title", "method", "icon"]);
            const titleResponse = title !== null && title !== void 0 ? title : method === null || method === void 0 ? void 0 : method.title;
            const iconResponse = icon !== null && icon !== void 0 ? icon : method === null || method === void 0 ? void 0 : method.icon;
            const translatedPaymentMethod = Object.assign(Object.assign({}, paymentMethod), { payment_method, title: __(`cart.order.payment_method.${payment_method !== null && payment_method !== void 0 ? payment_method : titleResponse}`, undefined, titleResponse) || titleResponse, icon: iconResponse });
            return translatedPaymentMethod;
        });
    }
}
//# sourceMappingURL=PgsApiLegacy.js.map